export default __webpack_public_path__ + "static/media/card.0579c5a4.webm";